import { MessageCircle } from 'lucide-react';

import { useCommunicationsWorkspace } from '../../context/CommunicationsWorkspaceContext';
import { Button } from '../ui/button';

export default function CommunicationsLauncher({ compact = false }) {
  const { canUse, unreadTotal, openInbox } = useCommunicationsWorkspace();
  if (!canUse) return null;

  return (
    <Button
      type="button"
      variant="ghost"
      size={compact ? 'icon' : 'sm'}
      className={compact ? 'relative' : 'relative gap-2'}
      onClick={openInbox}
      aria-label={unreadTotal > 0 ? `Messages, ${unreadTotal} unread` : 'Messages'}
      data-testid="communications-launcher"
    >
      <MessageCircle className="h-5 w-5" />
      {!compact ? <span>Messages</span> : null}
      {unreadTotal > 0 ? (
        <span
          className="absolute -right-1 -top-1 flex min-h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-bold text-white"
          data-testid="communications-unread-badge"
        >
          {unreadTotal > 99 ? '99+' : unreadTotal}
        </span>
      ) : null}
    </Button>
  );
}
